import React, { useContext } from 'react';
import { BarMouseOver, BarMouseOverState } from '../BarMouseOver';
import AppContext from 'app/AppContext';
import {
    PortfolioSummaryChartLegendData,
    getLegendData,
} from './portfolioSummaryLegendData';
import classNames from 'classnames';
import { PortfolioSummaryAggregatedData } from '../../store/data/PortfolioSummaryDataState';
import { PortfolioSummaryConfigurationState } from '../../store/instances/configuration/PortfolioSummaryConfigurationState';

import './PortfolioSummaryChartLegends.scss';
import { useShowBuysAsPositive } from 'app/store/appSettings/selectors';
import { FloatingLegend } from 'utils/components/FloatingLegend/FloatingLegend';

export interface PortfolioSummaryChartLegendsProps {
    chartHeight: number;
    config: PortfolioSummaryConfigurationState;
    data: PortfolioSummaryAggregatedData | undefined;
    mouseOver: BarMouseOver;
}

export default function PortfolioSummaryChartLegends(
    props: PortfolioSummaryChartLegendsProps
) {
    const { numberFormat, currencyFormat } = useContext(AppContext);
    const showBuysAsPositive = useShowBuysAsPositive();
    const { chartHeight, data, config, mouseOver } = props;
    const { quantities, sideNet } = config;

    const deriveLegendData = (mouseOverState: BarMouseOverState) => {
        return getLegendData(
            numberFormat,
            currencyFormat,
            config,
            showBuysAsPositive,
            data,
            mouseOverState
        );
    };

    const renderLegends = (legendData: PortfolioSummaryChartLegendData) => {
        if (legendData.bar === undefined) {
            return undefined;
        }

        if (sideNet === 'side' && legendData.bar === 'net') {
            return undefined;
        }
        if (sideNet === 'net' && legendData.bar !== 'net') {
            return undefined;
        }

        return (
            <>
                {quantities !== 'traded' &&
                    FloatingLegend.renderRow(
                        'Leaves',
                        legendData.remaining,
                        sideNet !== 'net'
                            ? legendData.remainingPercent
                            : undefined
                    )}
                {quantities !== 'leaves' &&
                    FloatingLegend.renderRow(
                        'Traded',
                        legendData.traded,
                        sideNet !== 'net' ? legendData.tradedPercent : undefined
                    )}
                {FloatingLegend.renderRow('Ordered', legendData.ordered)}
            </>
        );
    };

    const deriveLegendClasses = (
        legendData: PortfolioSummaryChartLegendData
    ) => {
        return classNames(
            quantities !== 'ordered' && 'small-height',
            legendData.bar
        );
    };

    return (
        <FloatingLegend
            className="PortfolioSummaryChartLegends"
            mouseOver={mouseOver}
            deriveLegendData={deriveLegendData}
            chartHeight={chartHeight}
            renderLegends={renderLegends}
            deriveLegendClasses={deriveLegendClasses}
        />
    );
}
